module.exports = __webpack_public_path__ + "static/media/25.4ddd6fb7.jpg";